import { MapSettingsItem } from 'components/map/Map';

interface MapLayerHubItemProps {
    isActive: boolean;
    onToggle: () => void;
}
export const MapLayerHubItem = ({ isActive, onToggle }: MapLayerHubItemProps) => {
    const icon = (
        <span
            data-active={isActive}
            className='rioglyph rioglyph-factory display-flex size-40 align-items-center justify-content-center text-200-percent data-active-false-text-gray data-active-true-text-primary'
        />
    );

    return (
        <MapSettingsItem label='Hubs' className='text-14' onClick={onToggle} isActive={isActive} inactiveIcon={icon} />
    );
};
